module.exports = __webpack_public_path__ + "static/media/know.a0441a74.png";